import { render } from "./BaseWysiwygEditor.vue?vue&type=template&id=0a9cd764&scoped=true"
import script from "./BaseWysiwygEditor.vue?vue&type=script&lang=ts"
export * from "./BaseWysiwygEditor.vue?vue&type=script&lang=ts"

import "./BaseWysiwygEditor.vue?vue&type=style&index=0&id=0a9cd764&scoped=true&lang=scss"
import "./BaseWysiwygEditor.vue?vue&type=style&index=1&id=0a9cd764&lang=scss"
script.render = render
script.__scopeId = "data-v-0a9cd764"

export default script